// extracted by mini-css-extract-plugin
export default {"heading":"About_heading__a8HIR","title":"About_title__YMonw","desc":"About_desc__uhuRS"};